import { FiltersRisk } from 'src/types.d'

const initialState: FiltersRisk = {}
export default (state = initialState, action) => {
  switch (action.type) {
    case 'filters/risk/set':
      return { ...state, ...action.payload }
    default:
      return state
  }
}
